import { render, staticRenderFns } from "./indexa.vue?vue&type=template&id=c3ffffc6&scoped=true"
import script from "./indexa.vue?vue&type=script&lang=js"
export * from "./indexa.vue?vue&type=script&lang=js"
import style0 from "./indexa.vue?vue&type=style&index=0&id=c3ffffc6&prod&scoped=true&lang=scss"
import style1 from "./indexa.vue?vue&type=style&index=1&id=c3ffffc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ffffc6",
  null
  
)

export default component.exports